module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./SearchView.js"));
	}, "DetailedListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DetailedListView!./src/pages/Promote/Schedule/DetailedList/Search/SearchView.js
// module id = 1162
// module chunks = 431